/* eslint-disable */
class Touch
{
    constructor({
        pixelMin = 10,
        onTop = event => event,
        onDown = event => event
    })
    {
        this.pixelMin = pixelMin
        this.isEnable = true


        // Callbacks
        this.onTop = onTop
        this.onDown = onDown


        // Listeners
        this._onTouchDown = this._onTouchDown.bind(this)
        this._onTouchEnd = this._onTouchEnd.bind(this)
        this._onTouchMove = this._onTouchMove.bind(this)


        document.addEventListener('touchstart', this._onTouchDown, false)
    }

    enable()
    {
        this.isEnable = true
    }

    disable()
    {
        this.isEnable = false
    }

    dispose()
    {
        document.removeEventListener('touchstart', this._onTouchDown)
        document.removeEventListener('touchend', this._onTouchEnd)
        document.removeEventListener('touchmove', this._onTouchMove)
    }

    _onTouchDown()
    {
        if (this.isEnable)
        {
            document.addEventListener('touchend', this._onTouchEnd, false)
            document.addEventListener('touchmove', this._onTouchMove, false)
        }
    }

    _onTouchMove(event)
    {
        this._touchDataY = event.touches[0].clientY
        if (this._touchDataYStart == undefined)
        {
            this._touchDataYStart = this._touchDataY
        }
    }

    _onTouchEnd(event)
    {
        if (Math.abs(this._touchDataY - this._touchDataYStart) > this.pixelMin)
        {
            if (this._touchDataY > this._touchDataYStart)
            {
                if (this.onTop)
                {
                    this.onTop(event)
                }
            }
            else
            {
                if (this.onDown)
                {
                    this.onDown(event)
                }
            }
        }

        this._touchDataYStart = undefined

        document.removeEventListener('touchend', this._onTouchEnd)
        document.removeEventListener('touchmove', this._onTouchMove)
    }
}

export default Touch
